import { defineStore } from 'pinia'

import type { AssessmentsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useAssessmentsStore = defineStore('assessments', {
  state: (): AssessmentsStore => ({
    assessments: [],
    assessmentAutologinUrl: null,
    assessmentAutologinSharedUrl: null,
    linkUpsellMath: null,
    linkUpsellEla: null,
    assessmentUpsellClosed: false,
  }),
  actions,
  getters,
})
